import { ButtonVariants } from '@/components/atoms/legacy/Button';
import ButtonLink from '@/components/atoms/legacy/ButtonLink/ButtonLink';
import Wrapper from '@/components/atoms/legacy/Wrapper';
import { CheckIcon } from '@heroicons/react/24/outline';

export const Success: React.FC = () => {
  return (
    <Wrapper>
      <div className="flex flex-col items-center pb-[40px]">
        <div className="mb-[16px] flex h-[48px] w-[48px] items-center justify-center rounded-3xl bg-brandElectric">
          <CheckIcon stroke="white" width={40} height={26} />
        </div>
        <span className="mb-[24px] text-center text-display32px md:text-display48px">
          Thank you for your interest in becoming a partner with us!
        </span>
        <span className="mb-[24px] text-center text-body16px">
          Our team will reach out to you. Meanwhile, visit our website to
          explore more about our partner benefits.
        </span>
        <ButtonLink
          variant={ButtonVariants.newDefault}
          href="/"
          className="mb-4 block w-full flex-none text-center text-bodyBold3 m:w-[250px] lg:inline-block"
        >
          Explore EV.com
        </ButtonLink>
        <ButtonLink
          variant={ButtonVariants.newPrimary}
          href="/partner"
          className="block w-full flex-none text-center text-bodyBold3 m:w-[310px] lg:inline-block"
        >
          Explore Partner Benefits
        </ButtonLink>
      </div>
    </Wrapper>
  );
};
